import createSource from './createSource';
import { MEDIA } from '@shoflo/polymer';

export default (number, order) => {
  return dispatch => {
    dispatch(
      createSource({
        title: `Content Placeholder ${number}`,
        type: MEDIA,
        value: '',
        order: order + 1
      })
    );
  };
};
